import {
  Box,
  ErrorContentIcon,
  Flex,
  ReloadScreenButton,
  Text,
  theme,
} from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  height?: string;
  reloadable?: boolean;
};

export const ErrorContent: FC<Props> = ({
  height = '400px',
  reloadable = true,
}) => {
  const { token } = theme.useToken();
  const { t } = useTranslation();

  return (
    <Flex
      style={{ background: token.colorFillContent, height }}
      align="center"
      justify="center"
      vertical
    >
      <ErrorContentIcon />
      <Box marginTop={32}>
        <Text variant="h5" text={t('error-message-general-error')} />
      </Box>
      {reloadable && (
        <>
          <Text
            style={{
              color: token.colorTextSecondary,
              marginTop: 16,
            }}
            text={t('request-message-reload')}
          />
          <Box marginTop={8}>
            <ReloadScreenButton />
          </Box>
        </>
      )}
    </Flex>
  );
};
